import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import qs from "qs";
import { IMall } from "shared/types/malls";

export const MallListApi = async () => {
  const { data } = await api.post<IMall[]>(
    API_ROUTES.MALL_LIST,
    qs.stringify({ ...defaultOptions() })
  );

  return data;
};
